<template>
  <v-container fluid grid-list-lg>    
      <v-layout wrap >
        
        <v-flex xs12 sm10 lg8>
        <v-card>
          <v-toolbar color="indigo" dark>

            <v-toolbar-title>{{label}}</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn :outlined="verActivos" small @click="toggleVerActivos">
              {{verActivos ? 'Ocultar dado de Baja' : 'Ver dado de Baja'}}
            </v-btn>
            <!-- <v-btn icon @click="addChild">
              <v-icon>add</v-icon>
            </v-btn> -->
          </v-toolbar>
          
         
          <v-list>
            <v-list-item v-for="tarjetaTokenizada in tarjetasMostradas" :key="tarjetaTokenizada.id">              
              <app-tarjeta-completo :value="tarjetaTokenizada" ref="hijos" :tarjetasExistentes="tarjetasTokenizadas"
                                        v-on:cancelar-ingreso="cancelarIngreso($event)"></app-tarjeta-completo>
            </v-list-item>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>    
  </v-container>  
</template>

<script>

import Vue from 'vue'
import { http } from '@/axios'

import {  

  mapMutations,  
} from 'vuex'

export default {
   data: () => ({    
    loading: false,
    verActivos:false,
    tarjetasTokenizadas: []  
  }),
  props: {
    value: {
      type: Object,
      required: false
    },
    propName:{
        type: String,
        required: false,
        default: 'tarjetasTokenizadas'
    },
    label: {
      type: String,
      default: 'Tarjetas'
    },
    iconName: {
      type: String,
      default: 'phone'
    }
  },
  watch:{
      'value.tarjetasTokenizadas': function(item){
        this.tarjetasTokenizadas = item;
        this.setTarjetas()
        this.MotivoBaja()
        console.log('tarjetasTokenizadas')
      }
  },
   created () {    
    // cargo el modelo
    this.setTarjetas()
    console.log(this.tarjetasTokenizadas.props)
  },
  computed:{
      tarjetasMostradas: function(){
        if(!this.tarjetasTokenizadas || this.tarjetasTokenizadas.activa == 0) return [];

       /* if(!this.verActivos){
          console.log('activo')
          return this.tarjetasTokenizadas.filter(dT => !dT.baja);
        }
        else
          return this.tarjetasTokenizadas
        
      }*/
      
      if(this.verActivos){
          return this.tarjetasTokenizadas;
        }
        else
          return this.tarjetasTokenizadas.filter(dT => dT.activa);
        
      }

  },
  methods: {
      ...mapMutations(["hideActiveSubTask","alertClear", "alertSuccess", "alertWarning", "alertError"]),
      setTarjetas(){
        if(!this.value[this.propName]){ // Si las tarjetas no están cargadas, creo la propiedad 
            this.tarjetasTokenizadas = []
            
            this.value[this.propName] = this.tarjetasTokenizadas
        }
        this.tarjetasTokenizadas = this.value[this.propName]
      },    
      async addChild(){

        const res = await this.$dialog.confirm({
          text: '¿Está seguro que quiere agregar una Tarjeta?',
          title: 'Confirmar Operación',
          persistent: true // Parece que no funciona...
        })

        if (!res) {
          return;
        }
        
        var ultimoOrden = 0; // Busco el último orden que hay
        for (let index = 0; index < this.tarjetasTokenizadas.length; index++) {
          ultimoOrden = this.tarjetasTokenizadas[index].orden;
        }

        //todo: al agregar cuenta, traer datos predeterminados (por ejemplo el prefijo en base a la sucursal, etc)

        var nuevaCuenta = {
              id: '00000000-0000-0000-0000-000000000000',
              emisor : '',
              numero: '',
              vecimiento: '',
              activa: true,
              tipo:'',
              token:'',
              tokenizadaPorId:'',
              ultimosDigitos:'',
              fechaAlta: this.$moment(new Date()).format('YYYY-MM-DD'),
              orden: ultimoOrden + 1      
        }

        this.tarjetasTokenizadas.push(nuevaCuenta);

        Vue.nextTick(() => { // esto es para esperar a que se renderice el componente nuevo
          this.$refs.hijos.find(ref=>ref.tarjetaTokenizada.id == nuevaCuenta.id).editModeOn = true;
        }); 
      },
      async deleteChild(tarjetasAEliminar){
        const res = await this.$dialog.prompt({
          text: 'Ingrese el Motivo de la Baja', 
          title: 'Confirmar Operación',
          persistent: true // Parece que no funciona...   
        })

        if (res) {
          console.log(tarjetasAEliminar)
          try {          
            await http.delete('creditos/deletetarjeta/' + tarjetasAEliminar.id + '/' + res);
            this.alertSuccess('La tarjeta ha sido dada de baja');
            tarjetasAEliminar.baja = true;
            
          } catch (error) {
              // Error
              Vue.$log.error(error);
              this.alertError(error)
          }

          

          // //Vue.$log.debug(indiceAEliminar);

          // if(indiceAEliminar >=0){
          //   this.tarjetasTokenizadas.splice(indiceAEliminar,1);
          // }
          
          this.value.motivoBajaTarjetaTokenizada = res
        }
      },
      cancelarIngreso(ordenAEliminar)
      {
        Vue.$log.debug(ordenAEliminar);
        var indiceAEliminar = -1;

        for (let index = 0; index < this.tarjetasTokenizadas.length; index++) {
            if(this.tarjetasTokenizadas[index].orden == ordenAEliminar){
              indiceAEliminar = index;
              break;
            }
        }
        if(indiceAEliminar >=0){
            this.tarjetasTokenizadas.splice(indiceAEliminar,1);
        }
      },
      toggleVerActivos(){
        this.verActivos = !this.verActivos;
      }
  }
}
</script>

<style>

</style>